import { render, staticRenderFns } from "./MixedNumberOfPlate.vue?vue&type=template&id=42c15ffc&"
import script from "./MixedNumberOfPlate.vue?vue&type=script&lang=js&"
export * from "./MixedNumberOfPlate.vue?vue&type=script&lang=js&"
import style0 from "./MixedNumberOfPlate.vue?vue&type=style&index=0&id=42c15ffc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports